export default {
  name: "apitools",
  methods: {
    getBadges() {
      this.$menuItems
        .filter(it => it.meta.badge)
        .forEach(rte => {
          this.getAndSetBadgeCountForModule(rte.name)
        })
    },
    getAndSetBadgeCountForModule(moduleName) {
      var url = `/api/${moduleName}/getcount`
      axios
        .get(url)
        .then(response => {
          this.setModuleBadge(moduleName, response.data.data.active)
        })
        .catch(error => {
          // this.$logError('apitools.getAndSetBadgeCountForModule', error, `Error ${url}`)
          console.log(`Crashed on apitools.getAndSetBadgeCountForModule ${url}`)
          console.log(error)
        })
    },
    badgeUpdating(moduleName) {
      var rte = this.getRouteItem(moduleName)
      if (rte != undefined) {
        rte.meta.badgeReady = false
      }
    },
    getRouteItem(moduleName) {
      var indx = _.findIndex(this.$menuItems, o => o.name === moduleName)
      return this.$menuItems[indx]
    },
    setModuleBadge(moduleName, badgeText) {
      var rte = this.getRouteItem(moduleName)
      rte.meta.badgeNumber = badgeText
      rte.meta.badgeReady = true
    },
    manageErrorMessage(error) {
      var errorMessage = `<p>Erreur, code: ${error.code}</p>`

      error.messages.forEach(function (message) {
        errorMessage = errorMessage.concat("<p>" + message + "</p>")
      })

      return errorMessage
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/apitools.js
// module id = HRBT
// module chunks = 18